export enum ReserveSlotsMode {
  CreateAppointment = 'CreateAppointment',
  EditAppointment = 'EditAppointment',
  PreviewAppointment = 'PreviewAppointment',
  CreateAbsence = 'CreateAbsence',
  EditAbsence = 'EditAbsence',
  BookAgain = 'BookAgain',
  OpenAgenda = 'OpenAgenda',
}
